import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
let ViedocDrawerList = class ViedocDrawerList extends LitElement {
    render() {
        return html `<ul>
      <slot></slot>
    </ul>`;
    }
};
ViedocDrawerList.styles = [
    css `
      ul {
        list-style: none;
        margin: 0;
        padding: 0;
      }
    `,
];
ViedocDrawerList = __decorate([
    customElement('viedoc-drawer-list')
], ViedocDrawerList);
export { ViedocDrawerList };
